
export const putUrl = process.env.NODE_ENV === 'production' ?
'/server/' :
'http://localhost:3000/server/'